const Container = ({ children, className, paddingClassName = 'px-4' }) => {
    return (
        <div className={`container mx-auto ${paddingClassName} ${className ?? ''}`}>
            {children}
        </div>
    )
}

export default Container;
